import { DatePipe, DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input, resource } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { MatTableModule } from '@angular/material/table';
import { RouterModule } from '@angular/router';

import { firstValueFrom } from 'rxjs';

import { Agreement } from '../schemas';
import { AgreementService, Auth, ClientService, Jira } from '../service';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { NextInvoiceDateForm } from './next-invoice-date-form';

@Component({
  selector: 'lcm-agreement-detail-table',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatTableModule, RouterModule, DecimalPipe, DatePipe, MatChipsModule, MatIconModule, MatButtonModule],
  templateUrl: './agreement-detail-table.html',
})
export class AgreementDetailTable {
  clientService = inject(ClientService);
  agreementService = inject(AgreementService);
  jira = inject(Jira);

  dialog = inject(MatDialog)
  agreement = input.required<Agreement>();

  auth = inject(Auth);

  canChangeInvoiceDate() {
    return  this.auth.isSuperAdmin();
  }


  projectValue = computed(() => {
    const agreement = this.agreement();
    const invoices = (agreement.Invoices || []).reduce((total, invoice) => total + invoice.InvoiceAmount, 0);

    const hours = (agreement.PurchasedHours || []).reduce(
      (total, item) => (item.Status === 20 ? total + item.Hours * item.HourlyRate : total),
      0,
    );

    return invoices + hours;
  });

  completedSpResource = resource({
    params: () => ({ agreement: this.agreement() }),
    defaultValue: 0,
    loader: async ({ params }) => {
      const info = await firstValueFrom(this.jira.getProjectSpCompleted(params.agreement.JiraTitle));
      return info.Done;
    },
  });

  completedSp = computed(() => this.completedSpResource.value());

  client = computed(() => this.clientService.clients().find((it) => it.ClientCode === this.agreement().ClientCode));

  changeInvoiceDate() {
    const data = {agreement: this.agreement()}
    this.dialog.open(NextInvoiceDateForm, {data}).afterClosed().subscribe({
      next: (result) => result && this.agreementService.reload()
    })
  }

}
